module.exports = __webpack_public_path__ + "img/star8.ff372ca1.png";